///jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\BooksCollectionListScreen.jsx
import { Table, Button, Row, Col, Container } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash, FaEye, FaEyeSlash, FaSort, FaList } from 'react-icons/fa';
import DOMPurify from 'dompurify';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import {
  useGetBooksCollectionsQuery,
  useDeleteBooksCollectionMutation,
  useToggleBooksCollectionVisibilityMutation,
  useToggleBooksCollectionInListMutation,
} from '../../slices/booksCollectionsApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';

const BooksCollectionListScreen = () => {
  const { pageNumber } = useParams();

  const [deleteBooksCollection, { isLoading: loadingDelete }] = useDeleteBooksCollectionMutation();
  const [toggleVisibility] = useToggleBooksCollectionVisibilityMutation();
  const [toggleInList] = useToggleBooksCollectionInListMutation();
  // const [toggleVisibility, { isLoading: loadingVisibility }] = useToggleBooksCollectionVisibilityMutation();
  // const [toggleInList, { isLoading: loadingInList }] = useToggleBooksCollectionInListMutation();

  const [sortConfig, setSortConfig] = useState({
    key: '_id', // Tri initial par ObjectId
    direction: 'asc', // Ordre décroissant par défaut
  });

  const navigate = useNavigate();

  const goToCreateBooksCollectionPage = () => {
    navigate('/admin/bookscollectionadd');
  };

  const deleteHandler = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette collection ?')) {
      try {
        await deleteBooksCollection(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const toggleVisibilityHandler = async (id) => {
    try {
      await toggleVisibility(id);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const toggleInListHandler = async (id) => {
    try {
      await toggleInList(id);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const { data, isLoading, error, refetch } = useGetBooksCollectionsQuery({
    pageNumber,
    isAdminSpace: true,
    sortKey: sortConfig.key,
    sortDirection: sortConfig.direction,
    parPage:40,
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
    refetch();
  };

  return (
    <Container>
      <Row className="align-items-center">
        <Col>
          <h1 style={{ cursor: 'pointer' }} onClick={() => handleSort('_id')}>
            Toutes les collections <FaSort />
          </h1>
        </Col>
        <Col className="text-end">
          <Button className="my-3" onClick={goToCreateBooksCollectionPage}>
            <FaPlus /> Ajouter une collection
          </Button>
        </Col>
      </Row>

      {loadingDelete && <Loader />}
      {/* {loadingVisibility && <Loader />} */}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error.data.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  Nom de la collection <FaSort />
                </th>
                <th onClick={() => handleSort('intention')} style={{ cursor: 'pointer' }}>
                  Intention <FaSort />
                </th>
                <th onClick={() => handleSort('isVisible')} style={{ cursor: 'pointer' }}>
                  Actions <FaEye style={{ color: 'grey' }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.booksCollections?.map((booksCollection) => (
                <tr key={booksCollection._id}>
                  <td>
                    <Link
                      to={`/admin/booksCollection/${booksCollection._id}/edit`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title="Modifier la fiche"
                    >
                      {booksCollection.name}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/admin/booksCollection/${booksCollection._id}/edit`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title="Modifier la fiche"
                    >
                      {booksCollection?.intention && <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(booksCollection?.intention?.slice(0, 50).replace(/<[^>]+>/g, '') + '...') }} />}
                    </Link>
                  </td>
                  <td>
                    <Button
                      as={Link}
                      to={`/admin/booksCollection/${booksCollection._id}/edit`}
                      variant="light"
                      className="btn-sm mx-2"
                      title="Modifier la fiche"
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => toggleVisibilityHandler(booksCollection._id)}
                      title={booksCollection.isVisible ? 'Cacher la fiche' : 'Rendre la fiche visible'}
                    >
                      {booksCollection.isVisible ? (
                        <>
                          <FaEye style={{ color: 'turquoise' }} />
                          <FaEyeSlash style={{ color: 'grey' }} />
                        </>
                      ) : (
                        <>
                          <FaEye style={{ color: 'grey' }} />
                          <FaEyeSlash style={{ color: 'red' }} />
                        </>
                      )}
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => deleteHandler(booksCollection._id)}
                      title={
                        booksCollection.isVisible
                          ? 'Seules les fiches non visibles peuvent être supprimées'
                          : 'Supprimer la fiche'
                      }
                      disabled={booksCollection.isVisible}
                    >
                      <FaTrash style={booksCollection.isVisible ? { color: 'grey' } : { color: 'red' }} />
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => toggleInListHandler(booksCollection._id)}
                      title={booksCollection.inList ? 'Cacher  la collection dans la liste' : 'Afficher la collection dans la liste'}
                    >
                      {booksCollection.inList ? (
                          <FaList style={{ color: 'turquoise' }} />
                      ) : (
                          <FaList style={{ color: 'red' }} />
                      )}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={data.pages} page={data.page} isAdmin={true} basePath="/admin/booksCollectionlist" />
        </>
      )}
    </Container>
  );
};

export default BooksCollectionListScreen;
